import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "split-table-layout" }
const _hoisted_13 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_14 = { class: "tab-title_left fl" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { style: {"padding":"6px 10px"} }
const _hoisted_17 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CommandRender = _resolveComponent("CommandRender")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_TableSplitter = _resolveComponent("TableSplitter")!
  const _component_TraceInfo = _resolveComponent("TraceInfo")!
  const _component_BusinessInfo = _resolveComponent("BusinessInfo")!
  const _component_ChargeFee = _resolveComponent("ChargeFee")!
  const _component_EngineerInfoList = _resolveComponent("EngineerInfoList")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "订单编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.no) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessNo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.businessNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "客户单号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerNo,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.customerNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "所属公司", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.titleId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.titleId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  onChange: _ctx.handleFilter,
                  clearable: "",
                  remote: "",
                  "remote-method": _ctx.getTitleOptionRemote,
                  size: _ctx.t('table.btnSize')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange", "remote-method", "size"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "客户公司", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerCompany,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.customerCompany) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "业务代表", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.salesManId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.salesManId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onFocus: _ctx.handleSalesManFocus,
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSalesManOptions(), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onFocus", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "结束日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[24] || (_cache[24] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[25] || (_cache[25] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))]),
          _cache[26] || (_cache[26] = _createStaticVNode("<span class=\"ml-10 filter-mark\"><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:red;\"></span><span class=\"status-text\">发起修改</span></span><span class=\"status-item\"><span class=\"status-square\" style=\"background-color:#ffa217;\"></span><span class=\"status-text\">退回订单</span></span></span>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", {
          class: "split-pane-top vue-grid-item",
          style: _normalizeStyle({ height: _ctx.isSubMenuCollapse ? '100%' : `${_ctx.topHeight}px` })
        }, [
          _withDirectives((_openBlock(), _createBlock(_component_TableList, {
            ref: el => { if (el) _ctx.tableListRef[0] = el },
            dataList: _ctx.list,
            columnAllData: _ctx.columnAllData,
            tableName: _ctx.TableName,
            permissionName: _ctx.permissionName,
            showSelection: true,
            showSummary: true,
            isShowPagination: false,
            handleDefaultWidth: 80,
            highlightCurrentRow: true,
            layoutHeight: true,
            newHpx: _ctx.newHpx,
            canRefresh: false,
            canChangeColumn: false,
            tableRowClassName: _ctx.tableRowClassName,
            style: {"height":"100%","overflow":"hidden"},
            onRowClick: _ctx.handleRowClick,
            onCommandChange: _ctx.handleCommand
          }, {
            "operation-action": _withCtx((scope) => [
              _createVNode(_component_CommandRender, {
                scopeRow: scope.row,
                codeList: _ctx.btnList,
                formPage: "order",
                permissionName: _ctx.permissionName,
                onCommandChange: _ctx.handleCommand
              }, null, 8, ["scopeRow", "codeList", "permissionName", "onCommandChange"])
            ]),
            _: 1
          }, 8, ["dataList", "columnAllData", "tableName", "permissionName", "newHpx", "tableRowClassName", "onRowClick", "onCommandChange"])), [
            [_directive_loading, _ctx.listLoading]
          ]),
          _withDirectives(_createVNode(_component_el_pagination, {
            class: "mt-20",
            total: _ctx.total,
            currentPage: _ctx.listQuery.page,
            "onUpdate:currentPage": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.listQuery.page) = $event)),
            "page-size": _ctx.listQuery.size,
            "page-sizes": _ctx.pageSizes,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            layout: "total, sizes, prev, pager, next"
          }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
            [_vShow, _ctx.total > 0]
          ])
        ], 4),
        (!_ctx.isSubMenuCollapse && _ctx.tabList.length)
          ? (_openBlock(), _createBlock(_component_TableSplitter, {
              key: 0,
              onDragStart: _ctx.handleSplitterDragStart,
              onDragMove: _ctx.handleSplitterDragMove,
              onDragEnd: _ctx.handleSplitterDragEnd
            }, null, 8, ["onDragStart", "onDragMove", "onDragEnd"]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          class: "split-pane-bottom",
          style: _normalizeStyle({ height: `${_ctx.bottomHeight}px` })
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                  onClick: ($event: any) => (_ctx.handleTabClick(item))
                }, _toDisplayString(item.name), 11, _hoisted_15))
              }), 128))
            ])
          ]),
          (_ctx.activeTab === 3)
            ? (_openBlock(), _createBlock(_component_TraceInfo, {
                key: 0,
                ref: "TraceInfo",
                id: _ctx.activeId,
                api: "order"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 2)
            ? (_openBlock(), _createBlock(_component_BusinessInfo, {
                key: 1,
                ref: "TraceInfo",
                id: _ctx.activeId,
                api: "order"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 1)
            ? (_openBlock(), _createBlock(_component_ChargeFee, {
                key: 2,
                ref: "ChargeFee",
                id: _ctx.activeId,
                api: "order"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 4)
            ? (_openBlock(), _createBlock(_component_EngineerInfoList, {
                key: 3,
                ref: "EngineerInfoList",
                id: _ctx.activeId
              }, null, 8, ["id"]))
            : _createCommentVNode("", true)
        ], 4), [
          [_vShow, !_ctx.isSubMenuCollapse && _ctx.tabList.length]
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: 'order',
          handleResolveTempData: _ctx.handleResolveTempData,
          "onUpdate:visibel": _cache[13] || (_cache[13] = () => _ctx.dialogFormVisible = false),
          onSubmit: _ctx.handleSubmit
        }, null, 8, ["id", "dialogFormVisible", "handleResolveTempData", "onSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.submitStepsVisible,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.submitStepsVisible) = $event)),
      title: "提示",
      width: "40%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _cache[14] || (_cache[14] = ($event: any) => {_ctx.submitStepsVisible = false;_ctx.stepsList = []})
          }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
              _createTextVNode("关闭", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepsList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: {"display":"flex","flex-flow":"column"}
          }, [
            _cache[27] || (_cache[27] = _createElementVNode("span", null, "第" + _toDisplayString(1) + "步:", -1)),
            _createElementVNode("span", _hoisted_16, _toDisplayString(item), 1)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (!_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          circle: "",
          onClick: _ctx.handleSubMenuCollapse,
          class: "subMenuCollapseBtn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isSubMenuCollapse ? '展开' : '收起'), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}